<template>
  <div id="investmentCalculator-component" class="investment-calculator-container">
    <PageHeader 
      title="Calculadora de Rentabilidad"
      subtitle="Herramienta para estimar la rentabilidad de sus inversiones y el crecimiento de su capital a lo largo del tiempo."
    />

    <div v-if="modal" class="modal-overlay">      
      <div class="modal-content card">
        <div class="modal-header">
          <h3 class="typo-headline-6">Información Adicional</h3>
          <button class="icon-button" @click="_closePopup()" aria-label="Cerrar modal">
            <span class="material-icons-outlined">close</span>        
          </button>
        </div>
        <p class="modal-prompt">¿Querría recibir información sobre productos de eurekers?</p>        
        
        <div v-for="(iItem, itemIndex) in input_capital_modal" :key="itemIndex">
          <div v-if="iItem.type == 'datos'">
            <div v-for="(iInput, inputIndex) in iItem.componentsConfig" :key="inputIndex" class="form-group">
              <label :for="iInput.input_key_to_save_user_values">{{ iInput.input_label }}</label>
              <input 
                :type="iInput.input_key_to_save_user_values === 'email' ? 'email' : (iInput.input_key_to_save_user_values === 'telefono' ? 'tel' : 'text')"
                :id="iInput.input_key_to_save_user_values"
                class="form-input"
                v-model="form_data_modal[iInput.input_key_to_save_user_values]"
                :placeholder="iInput.input_label"
                :maxlength="iInput.length"
                :pattern="iInput.input_key_to_save_user_values === 'telefono' ? '\\d{9}' : null"
              />
              <small v-if="iInput.helper_permission && iInput.input_helper" class="form-helper-text">{{ iInput.input_helper }}</small>
            </div>
          </div>          
        </div>
        <button class="button button-primary" @click="_sendDatos()">{{ button_name1 }}</button>        
      </div>
    </div>

    <div class="main-content-grid">
      <div class="form-panel card">
        <h3 id="inves-calc-title" class="typo-headline-6 section-title">Calcule su Rentabilidad</h3>
        <p class="typo-body-2 section-subtitle">Introduzca los detalles de su inversión para ver una proyección.</p>
        
        <div class="form-fields">
          <!-- Inversión Inicial -->
          <div class="form-group">
            <label for="valor_inicial">Inversión Inicial (€)</label>
            <input type="text" id="valor_inicial" class="form-input" v-model="valor_inicial" placeholder="Ej: 10000" @input="handleNumericInput('valor_inicial')">
            <small class="form-helper-text">Capital que invierte inicialmente.</small>
          </div>

          <!-- Valor Final -->
          <div class="form-group">
            <label for="valor_final">Valor Final de la Inversión (€)</label>
            <input type="text" id="valor_final" class="form-input" v-model="valor_final" placeholder="Ej: 15000" @input="handleNumericInput('valor_final')">
            <small class="form-helper-text">Valor que espera alcanzar.</small>
          </div>
          
          <!-- Años -->
          <div class="form-group">
            <label for="anos">Años Inversión</label>
            <input type="text" id="anos" class="form-input" v-model="años" placeholder="Ej: 5" @input="handleNumericInput('años')">
            <small class="form-helper-text">Número de años completos.</small>
          </div>

          <!-- Meses -->
          <div class="form-group" v-if="input_capital_select_meses">
            <label for="meses">{{ input_capital_select_meses.label_name }}</label>
            <select id="meses" class="form-select" v-model="meses">
              <option v-for="option in input_capital_select_meses.options" :key="option.value" :value="option.value">
                {{ option.name }}
              </option>
            </select>
            <small v-if="input_capital_select_meses.helper_select_permission" class="form-helper-text">
              {{ input_capital_select_meses.helper_text_select || 'Meses adicionales a los años.' }}
            </small>
          </div>
        </div>
        
        <button class="button button-primary button-calculate" @click="_pushPopUp()">{{ button_name }}</button>
      </div>

      <div class="results-panel card">
        <h3 class="typo-headline-6 section-title">Resultados Proyectados</h3>
        <div class="result-box">
          <p class="result-label">Conversión de Inversión</p>
          <p class="result-value">
            {{ valor_inicial_calculated }}€ &rarr; {{ valor_final_calculated }}€
          </p>
          <small class="result-detail">En {{ años_calculated }} años y {{ meses_calculated }} meses.</small>
        </div>
        <div class="result-box">
          <p class="result-label">RSI Simple Anualizado</p>
          <p class="result-value result-highlight">{{ resultado }} %</p>
        </div>
        <div class="result-box">
          <p class="result-label">ROI Anualizado Compuesto</p>
          <p class="result-value result-highlight">{{ resultadoROI }} %</p>
        </div>
      </div>
    </div>

    <div class="chart-panel card">
       <h3 class="typo-headline-6 section-title">Proyección Gráfica del Crecimiento</h3>
      <figure class="highcharts-figure">
          <div id="container"></div>
          <p class="highcharts-description typo-caption">
            Visualización del crecimiento de la inversión y los beneficios a lo largo del tiempo.
          </p>
      </figure>
    </div>
  </div>
</template>

<script>
// Removed Button, SelectOutline, InputTextOutline
import PageHeader from "@/components/common/PageHeader.vue";
import inputCapitalConfig from './configs/InvestmentCalculator/input_inversion.json';
import Highcharts from "highcharts";
import Vue from 'vue';
import { mapGetters } from "vuex";
import APICaller from "@/components/codeComponents/APICaller.js";

export default {
  mixins:[APICaller],
  name: 'InvestmentCalculator',

  metaInfo() {
    return {
      title: 'Calculadora de rentabilidad Eurekers',
      meta:[
        { name: 'description', content: "La calculadora de rentabilidad permite conocer cuánto tardarás en alcanzar tu objetivo de inversión y el % de rentabilidad anual necesario, ofrecida por Eurekers"}
      ]
    }
  },

  components: {
    PageHeader, // Added PageHeader
  },
  data() {
    return {
      // input_capital : inputCapitalConfig, // Keep for modal and select options
      valor_inicial : '', // Changed to string for text input
      valor_final : '',   // Changed to string for text input
      años : '' ,        // Changed to string for text input
      meses : 0,          // Kept as number for select
      
      form_data_modal: { // For modal inputs
        telefono: '',
        email: ''
      },

      valor_inicial_calculated : 0,
      valor_final_calculated : 0,
      años_calculated : 0 ,
      meses_calculated : 0,
      diasTotales : 0,
      resultado: 0,
      resultadoROI: 0,
      rsi: 0,
      contador: 0,
      modal: false,
      // telefono and email are now in form_data_modal
      categories: [],
      values: [
        {
            name: 'Beneficio inversión',
            data: [],
            stack: 'inversion'
          }, {
            name: 'Inversión original',
            data: [],
            stack: 'inversion'
          }
      ],

      button_name: "Calcular Rentabilidad", // Updated button text
      button_icon: "none", // Not used with vanilla button
      button_key: "button_key_calculate",

      button_name1: "Enviar Datos", // Updated button text
      button_icon1: "none", // Not used with vanilla button
      button_key1: "button_key_enviar",
    };
  },
  computed: {
    ...mapGetters(['is_mobile_device']),
    input_capital_modal() {
      return inputCapitalConfig.filter(item => item.type === 'datos');
    },
    input_capital_select_meses() {
      const selectConfig = inputCapitalConfig.find(item => item.ref === 'select_meses'); // Assuming a ref property exists
      if (selectConfig && selectConfig.componentsConfig && selectConfig.componentsConfig[0]) {
        return selectConfig.componentsConfig[0];
      }
      // Fallback if ref not found, try to find by type (less reliable)
      const genericSelect = inputCapitalConfig.find(item => item.type === 'select' || (item.componentsConfig && item.componentsConfig[0] && item.componentsConfig[0].options));
      return genericSelect ? genericSelect.componentsConfig[0] : { label_name: 'Meses Inversión', options: Array.from({length:12}, (_,i) => ({name: i, value: i})), helper_select_permission: true, helper_text_select: 'Seleccione los meses.'};
    }
  },
  mounted() {
    this.form_data_modal.telefono = this._getDatosFromCookies("telefono");
    this.form_data_modal.email = this._getDatosFromCookies("email");
    this._itsIframe();
  },
  methods: {
    handleNumericInput(fieldName) {
      let value = this[fieldName];
      if (typeof value !== 'string') value = String(value);

      // Allow only numbers and one decimal separator (dot or comma)
      value = value.replace(/[^0-9.,]/g, ''); 
      const parts = value.split(/[.,]/);
      if (parts.length > 2) {
        value = parts[0] + '.' + parts.slice(1).join('');
      } else if (parts.length === 2) {
         // Normalize to dot for internal consistency if needed, or leave as is for display
        value = parts[0] + '.' + parts[1];
      }
      // Optional: Max decimal places, e.g., /^\d*([.,]\d{0,2})?$/
      this[fieldName] = value;
    },
    _getParsedNumericValue(value) {
      if (value === null || value === undefined || value === '') return 0;
      const sValue = String(value).replace(',', '.');
      const num = parseFloat(sValue);
      return isNaN(num) ? 0 : num;
    },
    _getParsedIntValue(value) {
      if (value === null || value === undefined || value === '') return 0;
      const num = parseInt(value, 10);
      return isNaN(num) ? 0 : num;
    },
    _getDatosFromCookies:function(cname){
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    _itsIframe: function(){
      var URLactual = window.location;
      if(URLactual.search == "?=iframe"){
        // This might need adjustment if sidebar-nav-container is not always present or ID changes
        let sidebar = document.getElementById("sidebar-nav-container");
        if (sidebar) sidebar.style.display = "none";
      }
    },
    // _getDatos, _getValueFromInputComponent, _getValueFromSelectComponent are no longer needed
    // as v-model directly updates data properties. Parsing is handled by _getParsedNumericValue or in _testData.

    _pushPopUp(){
      // Use form_data_modal for phone and email checks
      if((this.contador == 2 || this.contador == 9) && (this.form_data_modal.telefono === "" && this.form_data_modal.email === "")){ 
        this.modal = true;
      }      
      this._testData();
    },
    _sendDatos: function(){
      let te = /^\d{9}$/;
      let em = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      // Use form_data_modal
      if(te.test(this.form_data_modal.telefono) && em.test(this.form_data_modal.email)){
        document.cookie = "telefono=" + this.form_data_modal.telefono + ";";
        document.cookie = "email=" + this.form_data_modal.email + ";";

        let data = new URLSearchParams();
        data.append('email', this.form_data_modal.email);
        data.append('tlf', this.form_data_modal.telefono);

        this._postInfo(data);
      }
      else {
         this.$vueOnToast.pop('error', 'Introduzca datos válidos en el formulario modal.');
      }
    },

    _postInfo(data){
      let success = response => {
        if(response.status == 200){
          this.$vueOnToast.pop('success', 'Datos enviados correctamente.');
          this._closePopup();
        } else{
          this.$vueOnToast.pop('error', 'Ha ocurrido un error. Por favor, inténtelo de nuevo.');
        }
      };
      let failure = () => {
        this.$vueOnToast.pop('error', 'Error de conexión al enviar datos. Por favor, inténtelo de nuevo.');
      };

      let url = "/calculadora/datos"; // Ensure this is the correct API endpoint

      const successHandler = new APICaller.SuccessHandler(success);
      // Providing a basic failure callback for network/API errors
      const failureHandler = new APICaller.FailureHandler('CALC_SEND_ERROR', 'Error en envío de datos de calculadora.', failure);

      this._postAPICall(url, data, successHandler, failureHandler);
    },

    _closePopup: function(){
      this.modal = false;
    },
    _testData(){
      const vInicial = this._getParsedNumericValue(this.valor_inicial);
      const vFinal = this._getParsedNumericValue(this.valor_final);
      const vAnos = this._getParsedNumericValue(this.años); // Allow decimals here if años can be e.g. 2.5
      const vMeses = this._getParsedIntValue(this.meses);

      // Check if original string inputs were empty, treat as 0 if so, but potentially flag as error if required
      const anosInputIsEmpty = this.años === null || String(this.años).trim() === '';


      if(vInicial > 0 && vFinal > 0){
        // If años field is empty but meses has a value, it's valid.
        // If años has a value, it should be >= 0.
        // If both are 0 or empty, it's an error.
        if( (vAnos > 0 || anosInputIsEmpty) || vMeses > 0 ){
            if (vAnos < 0) {
                 this.$vueOnToast.pop('error', 'Los años no pueden ser negativos.');
                 return;
            }
            // Check if años is integer if it's not empty
            if (!anosInputIsEmpty && !Number.isInteger(vAnos) && String(this.años).includes('.')) {
                 this.$vueOnToast.pop('error', 'Introduzca años sin decimales, utilice los meses para ello.');
                 return;
            }

            if(vAnos <= 100){
              this.valor_inicial_calculated = vInicial;
              this.valor_final_calculated = vFinal;
              this.años_calculated = Number.isInteger(vAnos) ? vAnos : 0; // Store integer part or 0 if empty/invalid for display
              this.meses_calculated = vMeses;
              
              this._calculateRSI();
              this._calculateROI();
              this.contador++;
            }
            else{
              this.$vueOnToast.pop('error', 'Introduzca años entre 0 y 100.');
            }              
        }
        else{
          this.$vueOnToast.pop('error', 'Introduzca una duración (años y/o meses) para la inversión.');
        }
      }
      else{
        this.$vueOnToast.pop('error', 'Introduzca una inversión inicial y final válidas (mayores que cero).');
      }

      if(this.is_mobile_device == true){
        setTimeout(() => {
          const resultsPanel = this.$el.querySelector('.results-panel');
          if (resultsPanel) {
            resultsPanel.scrollIntoView({ behavior: 'smooth' });
          } else {
            window.scrollTo(0, document.body.scrollHeight);
          }
        }, 500);
      }
    },
    _calculateRSI(){
      this.categories = []
      this.values[0].data = []
      this.values[1].data = []

      const vInicial = this.valor_inicial_calculated;
      const vFinal = this.valor_final_calculated;

      var dif = vFinal - vInicial;
      var rent = dif / vInicial;
      const timeInDays = this._TimetoDays();
      if (timeInDays === 0 && vInicial !== 0) { // Avoid division by zero if time is 0
         this.rsi = (vFinal > vInicial) ? Infinity : ((vFinal < vInicial) ? -Infinity : 0);
      } else if (vInicial === 0) {
         this.rsi = 0; // Or handle as an error/undefined case
      } else {
         this.rsi = rent * (365 / timeInDays);
      }
      
      if(Number.isFinite(this.rsi)) {
        this.resultado = parseFloat((this.rsi * 100).toFixed(3));
      } else {
        this.resultado = this.rsi; // Keep Infinity or -Infinity as is
      }
      this._prepareDataToHighchart();
    },
    _calculateROI(){
      const vInicial = this.valor_inicial_calculated;
      const vFinal = this.valor_final_calculated;
      const totalAnos = this._getParsedNumericValue(this.años_calculated) + (this._getParsedNumericValue(this.meses_calculated) / 12);

      if (vInicial === 0) {
        this.resultadoROI = 0; // Or handle as error
        return;
      }
      if (totalAnos === 0) {
         // If time is 0, ROI is simple percentage change if vFinal !== vInicial
         this.resultadoROI = ((vFinal - vInicial) / vInicial) * 100;
         if (Number.isFinite(this.resultadoROI)) this.resultadoROI = parseFloat(this.resultadoROI.toFixed(3));
         else this.resultadoROI = 0; // Default to 0 if calculation is problematic
         return;
      }

      var roi_decimal = (vFinal - vInicial) / vInicial; // This is the total ROI over the period
      // Annualized ROI: ( (1 + Total ROI)^(1/Years) ) - 1
      var annualized_roi = Math.pow((1 + roi_decimal), 1 / totalAnos) - 1;
      
      this.resultadoROI = parseFloat((annualized_roi * 100).toFixed(3));
    },
    _TimetoDays(){
      const vAnos = this.años_calculated; // Already parsed in _testData or should be
      const vMeses = this.meses_calculated;

      if(vAnos !== ''){ // Check against empty string if original input was empty
        // Use Number() to ensure conversion, as vAnos might be a string '0'
        this.diasTotales = Number(vAnos) * 365 + (vMeses / 12) * 365;
      }else{
        this.diasTotales =(vMeses / 12) * 365;
      }      
      return this.diasTotales;
    },    
    _calculateBenefit(n_years){ // n_years can be decimal representing years + fraction of year for months
      const vInicial = this.valor_inicial_calculated;
      const vFinal = this.valor_final_calculated;
      const totalPeriodYears = this.años_calculated + (this.meses_calculated / 12);

      if (vInicial === 0 || totalPeriodYears === 0) return 0;

      // Calculate effective annual rate based on ROI
      // ROI = (FV/PV)^(1/t) - 1
      const effectiveAnnualRate = Math.pow(vFinal / vInicial, 1 / totalPeriodYears) - 1;
      
      // Calculate compounded value at n_years: PV * (1 + R)^n
      // Benefit = Compounded Value - PV
      return (vInicial * Math.pow(1 + effectiveAnnualRate, n_years)) - vInicial;
    },
    _prepareDataToHighchart: function(){
        this.values[0].data = [];
        this.values[1].data = [];
        this.categories = [];

        const numAnos = this.años_calculated;
        const numMeses = this.meses_calculated;
        const vInicial = this.valor_inicial_calculated;

        if (vInicial === 0 && this.valor_final_calculated === 0) { // No investment, no chart
            this._addDataToHighchart(); // Call with empty data to clear chart
            return;
        }
        
        const isLoss = this.resultado < 0; // Using calculated RSI percentage
        this.values[0].name = isLoss ? "Pérdidas de la inversión" : "Beneficio inversión";

        // Case 1: Only years (and years > 0)
        if (numAnos > 0) {
            for(let k=1; k<= numAnos ; k++){
                this.categories.push(k === 1 ? k + ' año' : k + ' años');
                let benefit = parseFloat(this._calculateBenefit(k).toFixed(2));
                this.values[0].data.push(isLoss ? -benefit : benefit); // Store as positive for loss if name reflects it, or negative
                this.values[1].data.push(vInicial);
            }
        }

        // Case 2: Only months (and months > 0, years is 0 or empty)
        if ((numAnos === 0 || this.años === '') && numMeses > 0) {
            for(let l=1; l<= numMeses ; l++){
                let yearFraction = l / 12;
                this.categories.push(l === 1 ? l + ' mes' : l + ' meses');
                let benefit = parseFloat(this._calculateBenefit(yearFraction).toFixed(2));
                this.values[0].data.push(isLoss ? -benefit : benefit);
                this.values[1].data.push(vInicial);
            }
        }
        // Case 3: Both years and months are present and months > 0
        // Add a final point for the total duration including months, if years > 0 and months > 0
        if (numAnos > 0 && numMeses > 0) {
             let totalYearFraction = numAnos + (numMeses / 12);
             this.categories.push(parseFloat(totalYearFraction.toFixed(2)) + ' años');
             let benefit = parseFloat(this._calculateBenefit(totalYearFraction).toFixed(2));
             this.values[0].data.push(isLoss ? -benefit : benefit);
             this.values[1].data.push(vInicial);
        }
        
        // If no data points were added (e.g. 0 years 0 months), add initial state.
        if (this.categories.length === 0) {
            this.categories.push('Inicio');
            this.values[0].data.push(0); // No benefit at start
            this.values[1].data.push(vInicial);
        }

      this._addDataToHighchart();
    },
    _addDataToHighchart: function(){
      let categories = this.categories;
      let values = this.values;
      // Ensure Highcharts runs after DOM updates
      Vue.nextTick(function() {
        const chartElement = document.getElementById('container');
        if (!chartElement) {
            console.error("Highcharts container not found");
            return;
        }
        Highcharts.chart('container',{
          chart: {
            type: 'column',
            backgroundColor: 'var(--color-surface)',
          },
          title: {
            text: '', // Title removed, using section title in template
            style: { color: 'var(--color-text-primary)' }
          },
          colors: ['#00ADD9', '#0F0F1A'], // Eurekers Blue and Dark for contrast
          xAxis: {
            categories: categories,
            labels: { style: { color: 'var(--color-text-secondary)' } },
            lineColor: 'var(--color-outline)',
            tickColor: 'var(--color-outline)'
          },
          yAxis: {
            allowDecimals: true, // Allow decimals for currency
            min: 0,
            title: {
              text: 'Valor (€)',
              style: { color: 'var(--color-text-secondary)' }
            },
            labels: { style: { color: 'var(--color-text-secondary)' } },
            gridLineColor: 'var(--color-outline-variant)'
          },
          tooltip: {
            formatter: function () {
              return '<b>' + this.x + '</b><br/>' +
              this.series.name + ': ' + Highcharts.numberFormat(this.y, 2, ',', '.') + '€<br/>' +
              'Total Acumulado: ' + Highcharts.numberFormat(this.point.stackTotal, 2, ',', '.') + '€';
            },
            backgroundColor: 'var(--color-background-tooltip, rgba(0,0,0,0.8))',
            borderColor: 'var(--color-outline)',
            style: { color: 'var(--color-text-on-tooltip, #fff)' }
          },
          plotOptions: {
            column: {
              stacking: 'normal',
              borderColor: 'var(--color-surface)', // Border for columns matching background
            }
          },
          series: values,
          legend: {
            itemStyle: { color: 'var(--color-text-primary)' },
            itemHoverStyle: { color: 'var(--color-primary)' },
            backgroundColor: 'var(--color-surface-variant, var(--color-surface))',
            borderColor: 'var(--color-outline)'
          },
          credits: { enabled: false }
        });
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// Import common variables or define them here if not global
// Assuming variables like --color-background, --color-surface, --color-primary etc. are available globally.

.investment-calculator-container {
  background-color: var(--color-background);
  color: var(--color-text-primary);
  padding: 20px 5%;
  min-height: 100vh;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}

.card {
  background-color: var(--color-surface);
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.07);
  padding: 25px 30px; // Standardized padding
  margin-bottom: 30px;
  border: 1px solid var(--color-outline);
}

.section-title {
  color: var(--color-text-primary);
  margin-top: 0;
  margin-bottom: 8px; // Reduced margin
  padding-bottom: 10px;
  display: inline-block;
  font-weight: 500; // Ensure consistent weight
}

.section-subtitle {
  color: var(--color-text-secondary);
  margin-bottom: 25px; // Spacing after subtitle
  font-size: 0.9rem;
}

.main-content-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  align-items: start; // Align items to the start of the grid track
}

.form-panel {
  // Form panel takes available space
}

.form-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); // Responsive columns for inputs
  gap: 20px;
  margin-bottom: 25px;
}

.form-group {
  display: flex;
  flex-direction: column;
  label {
    display: block;
    margin-bottom: 8px;
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--color-text-secondary);
  }
}

.form-input,
.form-select {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid var(--color-outline);
  border-radius: 6px;
  background-color: var(--color-input-background, var(--color-surface));
  color: var(--color-text-primary);
  font-size: 1rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: var(--color-primary);
    box-shadow: 0 0 0 3px var(--color-primary-alpha, rgba(15, 174, 215, 0.25)); 
  }
  &::placeholder {
    color: var(--color-text-placeholder, var(--color-text-inactive));
    opacity: 0.7;
  }
}

.form-helper-text {
  margin-top: 6px;
  font-size: 0.75rem;
  color: var(--color-text-secondary);
}

.button {
  padding: 12px 20px;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
  border: 1px solid transparent;
  text-align: center;

  &.button-primary {
    background-color: var(--color-highlight);
    color: var(--color-on-primary, #fff);
    border-color: var(--color-highlight);
    &:hover {
      background-color: var(--color-primary-dark, hsl(195, 95%, 35%));
      border-color: var(--color-primary-dark, hsl(195, 95%, 35%));
    }
  }
}
.button-calculate {
  margin-top: 10px; // Adjusted from 25px
  width: 100%; // Make main calculate button full width
}


/* Results Panel Styling (inspired by Risk.vue) */
.results-panel {
  // Results panel takes available space
}
.result-box {
  background-color: var(--color-active-surface, var(--color-surface-variant));
  padding: 20px;
  border-radius: 8px;
  border: 1px solid var(--color-outline-variant, var(--color-outline));
  margin-bottom: 15px; // Space between result boxes
  &:last-child {
    margin-bottom: 0;
  }

  .result-label {
    font-size: 0.8125rem;
    font-weight: 600;
    color: var(--color-text-secondary);
    margin-bottom: 8px;
    text-transform: uppercase;
  }
  .result-value {
    font-size: 1.5rem; // Standardize result value size
    font-weight: 700;
    color: var(--color-text-primary); // Default color
    margin: 0;
    line-height: 1.2;
    &.result-highlight {
      color: var(--color-primary); // Highlight for key numbers
    }
  }
   .result-detail {
    font-size: 0.8rem;
    color: var(--color-text-secondary);
    margin-top: 4px;
  }
}

/* Chart Panel */
.chart-panel {
  // Takes full width on its own row in the main layout if needed
  // Or can be part of the grid if main-content-grid handles multiple rows
}
#container {
  height: 400px; // Default height for chart
  width: 100%;
}
.highcharts-figure {
  margin: 1em auto;
}
.highcharts-description {
  text-align: center;
  margin-top: 10px;
  color: var(--color-text-secondary);
}


/* Modal Styling */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000; // High z-index
  padding: 20px;
  box-sizing: border-box;
}
.modal-content {
  width: 100%;
  max-width: 500px; // Control max width of modal
  padding: 25px 30px; // Use card padding
  // background-color: var(--color-surface) already handled by .card
  // border-radius: 12px already handled by .card
  // box-shadow: 0 8px 25px rgba(0,0,0,0.15) handled by .card but can be stronger
  position: relative;

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid var(--color-outline);
    h3 { margin: 0; }
  }
  .icon-button {
    background: none;
    border: none;
    color: var(--color-text-secondary);
    font-size: 1.5rem; // For material icon size
    cursor: pointer;
    padding: 5px;
    line-height: 1;
    &:hover {
      color: var(--color-text-primary);
    }
    .material-icons-outlined { font-size: inherit; } // Ensure icon inherits size
  }
  .modal-prompt {
    margin-bottom: 20px;
    font-size: 1rem;
    color: var(--color-text-secondary);
  }
  .form-group { margin-bottom: 15px; }
  .button.button-primary { width: 100%; margin-top: 10px; }
}


/* Typography (ensure these are consistent with Directionality/Risk or define here) */
.typo-headline-6 { font-size: 1.25rem; font-weight: 500; line-height: 1.4; color: var(--color-text-primary); }
.typo-body-2 { font-size: 0.875rem; font-weight: 400; line-height: 1.5; color: var(--color-text-secondary); }
.typo-caption { font-size: 0.75rem; font-weight: 400; line-height: 1.66; color: var(--color-text-secondary); }


/* Responsive Adjustments */
@media (max-width: 960px) { // Tablet breakpoint
  .main-content-grid {
    grid-template-columns: 1fr; // Stack form and results on tablets
  }
}

@media (max-width: 600px) { // Mobile breakpoint
  .investment-calculator-container {
    padding: 15px;
  }
  .card {
    padding: 20px;
  }
  .form-fields {
    grid-template-columns: 1fr; // Stack form fields on mobile
  }
  .modal-content {
    padding: 20px;
    .modal-header h3 { font-size: 1.1rem; }
  }
  .button {
    padding: 10px 15px;
    font-size: 0.85rem;
  }
  .result-value {
    font-size: 1.3rem;
  }
}

/* Ensure Material Icons are available or replace with SVGs/other icon font */
.material-icons-outlined {
  font-family: 'Material Icons Outlined';
  font-weight: normal;
  font-style: normal;
  font-size: 24px; /* Preferred icon size */
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility;
  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;
  /* Support for IE. */
  font-feature-settings: 'liga';
}

// General h3, p styling if not covered by typo classes (Risk.vue applies this globally)
h3, p {
  color: var(--color-text-primary); // Default text color for these elements
}
// Ensure p in specific contexts get more specific styling if needed
.card p { // Example: p within cards might have a default
   // color: var(--color-text-secondary); // Or keep primary based on context
}

</style>

